import { AHIcon, AHText, Box, TouchableBox, useTheme , useUploadImage, Image, SPImageSource } from "arkh";
import Color from "color";
import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";

import { graphql, useMutation } from "react-relay";
import { useImageActionSheet } from "../../../components/mobile/useImageActionSheet";
import { PLUProductImageSectionUploadLinkMutation } from "./__generated__/PLUProductImageSectionUploadLinkMutation.graphql";

export function PLUProductImageSection(props: {
  image: SPImageSource | null;
  setImage(image: { id: string; uri: string } | null): void;
}) {
  const theme = useTheme();
  const { uploadImage, prepareForImageUpload } = useUploadImage();
  const [generateUploadLink] =
    useMutation<PLUProductImageSectionUploadLinkMutation>(graphql`
      mutation PLUProductImageSectionUploadLinkMutation {
        uploadImageLink {
          image {
            id
          }
          url
        }
      }
    `);
  const onAddImage = useCallback(
    async (
      uri: string,
      { width, height }: { width: number; height: number }
    ) => {
      const uploadIdRequest = prepareForImageUpload({
        width,
        height,
        localImageURI: uri,
      });
      generateUploadLink({
        variables: {},
        onCompleted: (data) => {
          uploadIdRequest.then((uploadId) => {
            if (data.uploadImageLink) {
              uploadImage({
                imageId: data.uploadImageLink.image.id,
                uploadURL: data.uploadImageLink.url,
                uploadId,
              });
              props.setImage({ uri, id: data.uploadImageLink.image.id });
            }
          });
        },
      });
    },
    [generateUploadLink, prepareForImageUpload, props, uploadImage]
  );

  const [openImageActionSheet, anchorRef] = useImageActionSheet({
    onAddImage,
    options: {
      allowsEditing: true,
      aspect: [1, 1],
    },
  });

  const renderImage = useCallback(() => {
    if (props.image === null) {
      return null;
    }
    return (
      <>
        <Image
          {...props.image}
          style={{ flex: 1, width: "100%", height: "100%" }}
          contentFit="cover"
          cachePolicy="memory-disk"
        />
        <Box
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            cornerRadius="medium"
            space="medium"
            style={{
              backgroundColor: Color(theme.background).alpha(0.9).toString(),
            }}
          >
            <AHIcon type="edit" color="primary" size="medium" />
          </Box>
        </Box>
      </>
    );
  }, [props.image, theme.background]);

  const renderAddImage = useCallback(() => {
    return (
      <>
        <AHIcon type="image" size="xlarge" color="primary" />
        <Box
          style={{ flexDirection: "row", alignItems: "center" }}
          spaceTop="small"
        >
          <AHText type="title-small" color="primary" spaceHorizontal="xsmall">
            <FormattedMessage
              defaultMessage="Add image"
              description="PLUProductImageSection add image"
            />
          </AHText>
        </Box>
      </>
    );
  }, []);

  return (
    <TouchableBox
      ref={anchorRef as any}
      color="surface"
      cornerRadius="medium"
      style={{
        width: 250,
        height: 150,
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "center",
        overflow: "hidden",
      }}
      onPress={() => {
        console.log("openImageActionSheet");
        openImageActionSheet();
      }}
    >
      {props.image ? renderImage() : renderAddImage()}
    </TouchableBox>
  );
}
